import React from "react";
import Navbar from "./global-components/navbar";
import Page_header from "./global-components/page-header";
import ServiceTwo from "./section-components/service-two";
import Property from "./property";
import PropertyByDubai from "./new-components/propertybydubai";
import PropertySell from "./new-components/property-sell";
import Footer from './global-components/footer';
import PropertyRent from "./new-components/propertyforRent";
import { Helmet } from "react-helmet";
import OurService from "./section-components/our-service";
import ServiceOne from "./section-components/service-one";
import PageHeaderService from "./global-components/page-headerservice";
import BlogHeader from "./global-components/Blog-Header";
import Faqs from "./section-components/faq";
import BlogContact from "../utils/blogContact";




const Services = () => {

    return (
        <div>
            <Helmet>
                <title>Real Estate Services in Dubai | Trinest Sky – Off-Plan & Luxury Experts</title>
                <meta name="description" content="Explore expert real estate services in Dubai – from off-plan property sales and luxury homes to international investment advisory. Contact us today." />
            </Helmet>
            <Navbar />
            {/* <Page_header headertitle="Our Services" /> */}
            <PageHeaderService headertitle="Our Services" />
            <ServiceOne />
            <ServiceTwo />
             <OurService/>
            <PropertyByDubai /> 
            <PropertySell />
            <PropertyRent />
            <Faqs />
            <div style={{paddingBottom : '35px'}}>
       <BlogContact />
    </div>
            <Footer />
        </div>
    )
}

export default Services